// Kindle Research Pro - Variant C: Limited Trial
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { BookOpen, Calculator, Zap } from 'lucide-react';
import { Layout } from '../Layout';

export default function KindleVariantC({
  LimitedDashboard, NicheModal, BookModal, UpgradeModal, getVariantBadge, sharedProps,
  niches, selectedNiche, books, categories, loadNicheBooks, bsrInput, setBsrInput, bsrResult,
  handleCalculateBsr, handleCreateNiche, handleAddBook, handleDeleteNiche, handleDeleteBook,
  handlePurchaseSetup, showNicheModal, setShowNicheModal, showBookModal, setShowBookModal,
  nicheForm, setNicheForm, bookForm, setBookForm, processing, showUpgradeModal,
  setShowUpgradeModal, upgradeMessage, paypalClientId
}) {
  return (
    <Layout>
      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                <BookOpen className="w-8 h-8 text-purple-600" />
                Kindle Research Pro
              </h1>
              <p className="text-gray-600">Limited Trial: 1 niche, 3 books max</p>
            </div>
            <div className="flex items-center gap-3">
              {getVariantBadge()}
              <Button onClick={handlePurchaseSetup} className="bg-purple-600 hover:bg-purple-700">
                <Zap className="w-4 h-4 mr-2" /> Upgrade
              </Button>
            </div>
          </div>

          <Card className="mb-6 border-green-200 bg-green-50">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div>
                    <span className="text-sm text-green-700">Niches:</span>
                    <span className="ml-2 font-bold">{niches.length}/1</span>
                  </div>
                  <div>
                    <span className="text-sm text-green-700">Books per niche:</span>
                    <span className="ml-2 font-bold">{selectedNiche ? books.length : 0}/3</span>
                  </div>
                  <div>
                    <span className="text-sm text-green-700">AI Features:</span>
                    <span className="ml-2 font-bold text-red-500">Locked</span>
                  </div>
                </div>
                <Button variant="outline" size="sm" onClick={handlePurchaseSetup}>
                  Unlock Unlimited
                </Button>
              </div>
            </CardContent>
          </Card>

          <LimitedDashboard 
            niches={niches}
            selectedNiche={selectedNiche}
            books={books}
            categories={categories}
            onSelectNiche={loadNicheBooks}
            onCreateNiche={() => setShowNicheModal(true)}
            onAddBook={() => setShowBookModal(true)}
            onDeleteNiche={handleDeleteNiche}
            onDeleteBook={handleDeleteBook}
            maxNiches={1}
            maxBooks={3}
            showAiFeatures={false}
            onUpgrade={handlePurchaseSetup}
          />

          <Card className="mt-6">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Calculator className="w-5 h-5" /> BSR Calculator
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex gap-2 max-w-md">
                <Input 
                  type="number"
                  value={bsrInput}
                  onChange={e => setBsrInput(e.target.value)}
                  placeholder="Enter BSR"
                />
                <Button onClick={handleCalculateBsr}>Calculate</Button>
              </div>
              {bsrResult && (
                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                  <div className="font-bold text-purple-600">{bsrResult.interpretation}</div>
                  <div className="text-sm text-gray-600 mt-1">
                    Est. {bsrResult.estimated_daily_sales} sales/day | ${bsrResult.revenue_estimates.monthly}/month
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>

      <NicheModal 
        open={showNicheModal}
        onClose={() => setShowNicheModal(false)}
        form={nicheForm}
        setForm={setNicheForm}
        categories={categories}
        onSubmit={handleCreateNiche}
        processing={processing}
      />
      <BookModal
        open={showBookModal}
        onClose={() => setShowBookModal(false)}
        form={bookForm}
        setForm={setBookForm}
        nicheName={selectedNiche?.name}
        onSubmit={handleAddBook}
        processing={processing}
      />
      <UpgradeModal paypalClientId={paypalClientId}
        open={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        message={upgradeMessage}
        onPurchase={handlePurchaseSetup}
        processing={processing}
      />
    </Layout>
  );
}
